import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { projectAccessGuard, projectRedirectGuard } from './services/project.guard';
import { ProjectSelectorComponent } from './components/project-selector/project-selector.component';

const routes: Routes = [
  // Standalone Project Selector & Project Management
  {
    path: 'projects',
    component: ProjectSelectorComponent,
    canActivate: [AuthGuard]
  },

  // Scoped Project Routes (/p/:projectId/...)
  {
    path: 'p/:projectId/t',
    loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule),
    canActivate: [AuthGuard, projectAccessGuard]
  },
  {
    path: 'p/:projectId/u',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuard, projectAccessGuard]
  },

  // User Support Portal Routes (/support/:projectId/portal)
  {
    path: 'support/:projectId/portal',
    loadChildren: () => import('./support-portal/support-portal.module').then(m => m.SupportPortalModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'support/:projectId',
    redirectTo: 'support/:projectId/portal',
    pathMatch: 'full'
  },

  // Root redirect resolving active project
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard, projectRedirectGuard]
  },

  // Legacy route compatibility (redirects /t/... and /u/... to /p/:activeId/...)
  {
    path: 't',
    canActivate: [AuthGuard, projectRedirectGuard],
    children: [
      {
        path: '**',
        canActivate: [AuthGuard, projectRedirectGuard]
      }
    ]
  },
  {
    path: 'u',
    canActivate: [AuthGuard, projectRedirectGuard],
    children: [
      {
        path: '**',
        canActivate: [AuthGuard, projectRedirectGuard]
      }
    ]
  },

  // Wildcard fallback
  {
    path: '**',
    canActivate: [AuthGuard, projectRedirectGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
